import { Component } from 'react';
import { Footer, HeaderModern, Loader, Slider, TopBar, TopHeader } from '../layouts/general';
import { Project } from '../layouts/general/projects';
import { ServiceCards } from '../layouts/general/services';
import { Testimonials } from '../layouts/home06';

class Home02 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headers: [
                {
                    id: 1,
                    names: 'Home Modern Header'
                }
            ],
        }
    }

    render() {
        return (
            <div className="bg-body">
                <div className="boxed">
                    <Loader />
                    <TopBar />
                    <TopHeader />
                    {
                        this.state.headers.map(data => (
                            <HeaderModern data={data} key={data.id}/>
                        ))
                    }

                    <Slider />

                    <ServiceCards limit={4} showViewAll showTitle />

                    <Project />

                    <Testimonials />

                    {/* <Callback /> */}

                    {/* <CarouselClient />*/}

                    <Footer />
                </div>
            </div>
        );
    }
}

export default Home02;
